import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading5XL,
} from "../../../typography";

import { CAREERS_URL } from "../../navigation/config/navConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

export const Hero = () => (
  <div className="tw-relative tw-flex tw-items-center tw-gap-y-[2em]">
    <div className="tw-mb-[4em] tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-x-[3.5em] tw-gap-y-[2.625em] min440:tw-flex-row min440:tw-px-[1.5em]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[1.25em] tw-text-center min440:tw-w-1/2 min440:tw-items-start min440:tw-text-left">
        <Heading2XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min840:tw-flex">
          Life at Verse
        </Heading2XL>
        <Heading5XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min840:tw-flex">
          Join the team changing healthcare at home with software.
        </Heading5XL>
        <Heading2XL className="tw-my-0 tw-w-full tw-text-white min840:tw-hidden">
          Join the team changing healthcare at home with software.
        </Heading2XL>
        <BodyXL className="tw-my-0 tw-hidden tw-text-white min840:tw-flex">
          We're building software that enables hospital-quality care at home.
        </BodyXL>
        <BodyLG className="tw-my-0 tw-text-white min840:tw-hidden">
          We're building software that enables hospital-quality care at home.
        </BodyLG>
        <a
          href={CAREERS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-no-underline"
        >
          <StandardButton
            onClick={() => {}}
            style={"primary-blue"}
            className="tw-flex tw-w-[15em] tw-items-center tw-justify-center tw-gap-x-[.5em] tw-rounded-full tw-px-[2em] tw-py-[1.25em] tw-text-[16px] min440:tw-mt-[1em]"
          >
            <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
              View job openings
            </BodyLGB>
            <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
              View job openings
            </BodyMDB>
            <FontAwesomeIcon
              icon={faUpRightFromSquare}
              className="tw-h-[1em] tw-w-[1em]"
            />
          </StandardButton>
        </a>
      </div>
      <div className="tw-flex tw-aspect-[570/525] tw-w-full min440:tw-w-1/2">
        <RiveAnimation
          fallbackClassName="tw-h-full tw-w-full"
          fallbackSrc="/landing_page_assets/why_verse/WhyVerse5.png"
        />
      </div>
    </div>
  </div>
);
